export const SCHEDULES_QUERY_KEY = 'schedules'
export const ARCHIVED_SCHEDULES_QUERY_KEY = 'archivedSchedules'
export const EMPLOYEE_SCHEDULES_QUERY_KEY = 'employeeSchedules'
